import isEmpty from '@naverpay/hidash/isEmpty'
import {every} from 'lodash/fp'

export function validURL(str: string) {
    return new RegExp(
        '^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$',
        'i',
    ).test(str)
}

/**
 * 입력된 문자열이 휴대폰번호가 맞는지 검증
 * @param mobileNumber 검증대상 휴대폰 번호
 */
export const validateMobileNumber = (mobileNumber: string) => {
    const mobileReg = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/
    return mobileReg.test(mobileNumber)
}

/** 배열 내의 모든 요소가 empty 인지 여부를 반환합니다. */
export const isEveryEmpty = every(isEmpty)

/** 문자열에 한국어가 포함되어 있는지 여부 */
export const isKoreanIncluded = (phrase: string) => {
    const validation = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
    return validation.test(phrase)
}
